<template>
  <div>
    <div
      class="d-flex mb-1"
      style="font-size: 14px; color: #606266"
      v-if="formData.modifyTime"
    >
      <div
        class="side-frame-success"
        style="height: inherit;margin: 0;min-height: 21px;"
      ></div>
      <div>
        <el-tag
          size="mini"
          :type="formData.status === 'Y' ? 'success' : 'danger'"
        >
          {{ formData.v_status || 'New' }}
        </el-tag>
        <el-divider direction="vertical"></el-divider>
        <span>
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
      </div>
    </div>

    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="'平台'" prop="platformId">
            <el-input v-model="formData.platformName" readonly size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="'平台账户'" prop="platformAccountCode">
            <el-input v-model="formData.accountName" readonly size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="'销售渠道'" prop="salesChannelId">
            <el-select
              v-model="formData.salesChannelId"
              :placeholder="'请选择模板类型'"
              style="width: 100%"
              filterable
              size="small"
              @change="(val) => onSalesChnage(val)"
            >
              <el-option
                v-for="item in salesChanneOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="platformTemplateCode">
        <el-col :span="24">
          <el-form-item :label="'渠道模板'" prop="templateCode">
            <!-- <dict-select
              filterable
              size="small"
              clearable
              v-model="formData.templateCode"
              url="/ecomorder/ecom/platform/select/template"
              :placeholder="'请选择渠道模板'"
            ></dict-select> -->
            <el-input
              v-model="formData.templateName"
              readonly
              :placeholder="'请选择渠道模板'"
            >
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="
                  () => {
                    chooseTemplateVisible = true
                  }
                "
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="'模板类型'" prop="templateType">
            <el-select
              v-model="formData.templateType"
              :placeholder="'请选择模板类型'"
              style="width: 100%"
              filterable
            >
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-else>
        <ItemTable ref="itemTable" :disabled="disabled" />
      </el-row>
    </el-form>
    <chooseTemplate
      :visible.sync="chooseTemplateVisible"
      :templateQueryParams="{ templateGroup: 'Order-Sync-Template' }"
      @confirm="(val) => templateConfirm(val)"
    />
    <el-dialog
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
      :modal-append-to-body="false"
      :modal="false"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ItemTable from '../item-table'
import chooseTemplate from '../choose-template'
import { request } from '@/api/service'
export default {
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    platformTemplateCode: { type: String, default: '' },
  },
  components: { ItemTable, chooseTemplate },
  data() {
    return {
      ecomPmaCodeParams: { platformType: 'E' },
      formData: {},
      optionData: [],
      chooseTemplateVisible: false,
      selectOptions: [
        { label: '新建', value: 'CREATE' },
        { label: '确认', value: 'ACKNOWLEDGE' },
        { label: '发运', value: 'SHIP' },
        { label: '送达', value: 'DELIVER' },
        { label: '取消', value: 'CANCEL' },
        { label: '退款', value: 'REFUND' },
        { label: '附件变更', value: 'CHANGE_FILE' },
        { label: '库存变更', value: 'CHANGE_INV' },
        { label: '订单拉取', value: 'PULL' },
        { label: '发票', value: 'INVOICE' },
      ],
      salesChanneOptions: [],
      rules: {
        platformId: [
          {
            required: true,
            message: '请选择销售渠道...',
            trigger: 'change',
          },
        ],
        platformAccountCode: [
          {
            required: true,
            message: '请选择销售渠道...',
            trigger: 'change',
          },
        ],
        salesChannelId: [
          {
            required: true,
            message: '请选择销售渠道...',
            trigger: 'change',
          },
        ],
        templateCode: [
          {
            required: true,
            message: '请选择渠道模板...',
            trigger: 'change',
          },
        ],
        templateType: [
          {
            required: true,
            message: '请选择模板类型...',
            trigger: 'change',
          },
        ],
      },
      backDialogVisible: false,
    }
  },
  async mounted() {
    await this.init()
    this.getData()
  },
  methods: {
    getData() {
      if (!this.platformTemplateCode) return
      this.$api
        .ecomOrderPlatformTransformTemplateDetailApi({
          platformTemplateCode: this.platformTemplateCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async init() {
      request({
        url: '/ecomorder/ecom/platform/select/evgPlatform',
        method: 'POST',
      }).then((res) => {
        this.salesChanneOptions = res.body.data
      })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      if (this.platformTemplateCode) {
        this.formData.itemList = [
          {
            templateCode: this.formData.templateCode,
            templateType: this.formData.templateType,
          },
        ]
      } else {
        const itemTableResult = await this.$refs.itemTable.validate()
        if (!itemTableResult) return (this.backDialogVisible = false)
        this.formData.itemList = this.$refs.itemTable.getTableData()
      }

      this.loadingOpen()
      const res = await this.$api
        .ecomOrderPlatformTransformTemplateSaveApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      this.loadingClose()
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.$emit('close')
      this.backDialogVisible = false
    },
    onSalesChnage(val) {
      this.salesChanneOptions.forEach((item) => {
        if (item.value === val) {
          this.formData.label = item.label
          this.formData.platformAccountCode = item.platformAccountCode
          this.formData.accountName = item.accountName
          this.formData.platformId = item.platformId
          this.formData.platformName = item.platformName
        }
      })
    },
    templateConfirm(val) {
      this.formData.templateName = val.templateName
      this.formData.templateCode = val.templateCode
      this.chooseTemplateVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
